document.addEventListener('DOMContentLoaded', function () {
  const table = document.getElementById('size-table');
  if (!table) return;

  const btnCm = document.getElementById('btn-cm');
  const btnIn = document.getElementById('btn-in');
  if (!btnCm || !btnIn) return;

  // Colonnes à convertir (index 1, 2, 3 — on ignore la colonne Taille en index 0)
  const convertColumns = [1, 2, 3];

  // Lire et stocker les valeurs cm au chargement
  const rows = table.querySelectorAll('tbody tr');
  const originalValues = [];

  rows.forEach(function (row) {
    const cells = row.querySelectorAll('td');
    const rowData = [];
    convertColumns.forEach(function (colIndex) {
      const val = parseFloat(cells[colIndex]?.textContent.trim());
      rowData.push(isNaN(val) ? null : val);
    });
    originalValues.push(rowData);
  });

  function setUnit(unit) {
    // Mettre à jour les labels dans les en-têtes
    table.querySelectorAll('th .unit-label').forEach(function (el) {
      el.textContent = unit;
    });

    // Mettre à jour les cellules
    rows.forEach(function (row, rowIndex) {
      const cells = row.querySelectorAll('td');
      convertColumns.forEach(function (colIndex, i) {
        const cmVal = originalValues[rowIndex][i];
        if (cmVal === null) return;
        if (unit === 'in') {
          cells[colIndex].textContent = (cmVal * 0.3937).toFixed(1);
        } else {
          cells[colIndex].textContent = cmVal;
        }
      });
    });

    // Mettre à jour les boutons
    btnCm.classList.toggle('active', unit === 'cm');
    btnIn.classList.toggle('active', unit === 'in');
  }

  btnCm.addEventListener('click', function () { setUnit('cm'); });
  btnIn.addEventListener('click', function () { setUnit('in'); });
});
